<template>
  <div class="change-password-container">
    <el-card class="box-card" header="修改密碼">
      <el-form :model="passwordForm" :rules="passwordRules" ref="passwordFormRef" label-width="120px" style="max-width: 600px;">
        <el-form-item :label="$t('common.old_password')" prop="old_password">
          <el-input type="password" v-model="passwordForm.old_password" show-password />
        </el-form-item>
        <el-form-item :label="$t('common.new_password')" prop="new_password">
          <el-input type="password" v-model="passwordForm.new_password" show-password />
        </el-form-item>
        <el-form-item :label="$t('common.confirm_password')" prop="confirm_password">
          <el-input type="password" v-model="passwordForm.confirm_password" show-password />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm" :loading="loading">{{ $t('common.submit') }}</el-button>
          <el-button @click="resetForm">{{ $t('common.reset') }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { ElMessage } from 'element-plus'
import { changePassword } from '@/api'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const passwordFormRef = ref(null)
const loading = ref(false)

const passwordForm = reactive({
  old_password: '',
  new_password: '',
  confirm_password: ''
})

const validatePass = (rule, value, callback) => {
  if (value === '') {
    callback(new Error(t('common.new_password') + t('common.required')))
  } else if (value.length < 6) {
    callback(new Error('密碼長度不能少於6位'))
  } else {
    if (passwordForm.confirm_password !== '') {
      passwordFormRef.value.validateField('confirm_password')
    }
    callback()
  }
}

const validatePass2 = (rule, value, callback) => {
  if (value === '') {
    callback(new Error(t('common.confirm_password') + t('common.required')))
  } else if (value !== passwordForm.new_password) {
    callback(new Error('兩次輸入的密碼不一致!'))
  } else {
    callback()
  }
}

const passwordRules = reactive({
  old_password: [
    { required: true, message: t('common.old_password') + t('common.required'), trigger: 'blur' }
  ],
  new_password: [
    { required: true, validator: validatePass, trigger: 'blur' }
  ],
  confirm_password: [
    { required: true, validator: validatePass2, trigger: 'blur' }
  ]
})

const submitForm = () => {
  passwordFormRef.value.validate(async (valid) => {
    if (valid) {
      loading.value = true
      try {
        const data = {
          old_password: passwordForm.old_password,
          new_password: passwordForm.new_password
        }
        const res = await changePassword(data)
        if (res.code === 200) {
          ElMessage.success(t('common.save_success'))
          resetForm()
        }
      } catch (error) {
        // 错误已在 axios 拦截器中处理
      } finally {
        loading.value = false
      }
    }
  })
}

const resetForm = () => {
  passwordFormRef.value.resetFields()
}
</script>

<style scoped>
.change-password-container {
  padding: 20px;
}
</style>
